var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.data,"extra-info":_vm.extraInfo,"base-info":_vm.baseInfo,"name-rules":[{ required: true, message: _vm.$t('compute.text_210') }],"columns":_vm.serverColumns,"auto-hidden-columns-key":"server_hidden_columns","status-module":"server","resource":"servers"}})
}
var staticRenderFns = []

export { render, staticRenderFns }